import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'enumToArray',
  standalone: false,
})
export class EnumToArrayPipe implements PipeTransform {
  transform(data: Object) {
    return (data) ? Object.keys(data) : undefined;
  }
}
